<template>
  <Modal
    title="Edit a submitted form?"
    class-name="small-modal"
    submit-btn-text="Edit answers"
    @hide-modal="emit('hide-modal')"
    @submit="emit('confirm')"
  >
    <!-- The presence hook sits on this wrapper rather than on Modal: Modal
         renders through SafeTeleport, so a data-cy passed to it as an attribute
         never reaches the DOM. -->
    <div data-cy="cf-amend-warning">
      <p class="text-sm text-gray-700" data-cy="cf-amend-warning-body">
        This form has been submitted. Changing an answer puts it back to
        <strong>In Progress</strong>, so it will need to be submitted again.
      </p>

      <p
        v-if="requiredForClose"
        class="mt-3 text-sm text-gray-700"
        data-cy="cf-amend-warning-close-out"
      >
        This form is required to close, so the appointment cannot be completed
        until it is submitted again.
      </p>

      <p class="mt-3 text-sm text-gray-500" data-cy="cf-amend-warning-pdf">
        Submitting again files a new PDF on the job. Any copy already sent to
        the customer stays as it was sent.
      </p>
    </div>
  </Modal>
</template>

<script setup lang="ts">
// Bespoke rather than the shared confirmChanges/ConfirmationModal: that one
// hardcodes a "Continue" button and renders one v-html string, and this needs its
// own verb, a conditional paragraph, and per-paragraph hooks the specs assert on.
import Modal from "@/components/Modal.vue";

withDefaults(defineProps<{ requiredForClose?: boolean }>(), {
  requiredForClose: false
});

const emit = defineEmits<{
  "hide-modal": [];
  confirm: [];
}>();
</script>
